// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"fcfdc0296e5bf86caef0","276":"02508f3546d5cc70c090"}[chunkId] + ".js";
};